import React from 'react';
import './Symptoms.scss';
import IconList from '../../components/IconList/IconList';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import iconOne from '../../assets/symptoms/1.png';
import iconTwo from '../../assets/symptoms/2.png';
import iconThree from '../../assets/symptoms/3.png';
import iconFour from '../../assets/symptoms/4.png';
import iconFive from '../../assets/symptoms/5.png';
import { useLocation } from 'react-router-dom';

const Symptoms = () => {
    const location = useLocation();
    const path = location.pathname.substring(1); // Remove the leading slash

    // Default symptoms for root canals
    const rootCanalSymptoms = [
        {
            'icon': iconOne,
            'title': 'Spontaneous pain',
            'description': 'Spontaneous pain even when you\'re not eating or drinking'
        },
        {
            'icon': iconTwo,
            'title': 'Discoloration of tooth',
            'description': 'Darkening or discoloration of a tooth'
        },
        {
            'icon': iconThree,
            'title': 'Middle night pain',
            'description': 'Pain that wakes you up in the middle of the night'
        },
        {
            'icon': iconFour,
            'title': 'Tenderness in gums',
            'description': 'Swelling or tenderness in the gums near the affected tooth'
        },
        {
            'icon': iconFive,
            'title': 'Extreme sensitivity',
            'description': 'Extreme sensitivity to cold or heat when you drink or eat'
        }
    ];

    // Symptoms for dental implants
    const implantSymptoms = [
        {
            'icon': iconOne,
            'title': 'Missing teeth',
            'description': 'One or more missing teeth that affect your smile and function'
        },
        {
            'icon': iconTwo,
            'title': 'Bone loss',
            'description': 'Jawbone deterioration due to missing teeth'
        },
        {
            'icon': iconThree,
            'title': 'Difficulty chewing',
            'description': 'Problems with eating certain foods due to missing teeth'
        },
        {
            'icon': iconFour,
            'title': 'Speech issues',
            'description': 'Difficulty speaking clearly due to gaps in teeth'
        },
        {
            'icon': iconFive,
            'title': 'Facial appearance',
            'description': 'Changes in facial structure due to missing teeth'
        }
    ];

    // Symptoms for teeth whitening
    const whiteningSymptoms = [
        {
            'icon': iconOne,
            'title': 'Stained teeth',
            'description': 'Discoloration from coffee, tea, wine, or tobacco use'
        },
        {
            'icon': iconTwo,
            'title': 'Yellow teeth',
            'description': 'Yellowing of teeth due to aging or genetics'
        },
        {
            'icon': iconThree,
            'title': 'Special occasion',
            'description': 'Preparing for a wedding, job interview, or special event'
        },
        {
            'icon': iconFour,
            'title': 'Low confidence',
            'description': 'Feeling self-conscious about your smile'
        },
        {
            'icon': iconFive,
            'title': 'Previous treatments',
            'description': 'Over-the-counter products not providing desired results'
        }
    ];

    // Symptoms for orthodontics
    const orthodonticsSymptoms = [
        {
            'icon': iconOne,
            'title': 'Crooked teeth',
            'description': 'Teeth that are visibly misaligned or crowded'
        },
        {
            'icon': iconTwo,
            'title': 'Bite problems',
            'description': 'Overbite, underbite, or crossbite issues'
        },
        {
            'icon': iconThree,
            'title': 'Spacing issues',
            'description': 'Gaps between teeth or overcrowding'
        },
        {
            'icon': iconFour,
            'title': 'Jaw pain',
            'description': 'Discomfort in the jaw due to misalignment'
        },
        {
            'icon': iconFive,
            'title': 'Difficulty cleaning',
            'description': 'Problems properly brushing and flossing due to alignment'
        }
    ];

    // Map paths to symptoms and titles
    const serviceInfo = {
        'root-canals': {
            symptoms: rootCanalSymptoms,
            title: 'Signs and symptoms you need a root canal',
            description: 'If you experience any of these symptoms, you may need a root canal treatment. Contact Loft Dentaire Laval for a consultation.'
        },
        'dental-implants': {
            symptoms: implantSymptoms,
            title: 'Signs you might need dental implants',
            description: 'Dental implants can restore your smile and function. Here are some signs that implants might be right for you.'
        },
        'teeth-whitening': {
            symptoms: whiteningSymptoms,
            title: 'Reasons to consider teeth whitening',
            description: 'Professional teeth whitening at Loft Dentaire Laval can help address these common concerns.'
        },
        'orthodontics': {
            symptoms: orthodonticsSymptoms,
            title: 'Signs you might need orthodontic treatment',
            description: 'Orthodontic treatment at Loft Dentaire Laval can help correct these issues for a healthier, more beautiful smile.'
        },
        'invisalign': {
            symptoms: orthodonticsSymptoms,
            title: 'Signs you might be a candidate for Invisalign',
            description: 'Invisalign can help address these common orthodontic issues with clear, removable aligners.'
        }
    };

    // Default to root canal symptoms if no match
    const currentService = serviceInfo[path] || serviceInfo['root-canals'];
    const symptomsData = currentService.symptoms;
    const sectionTitle = currentService.title;
    const sectionDescription = currentService.description;

    return (
        <section className='symptoms-section section-common pt-100 pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <SectionTitle
                    subTitle="Information"
                    title={sectionTitle}
                    description={sectionDescription}
                />

                <div className="row">
                    {
                        symptomsData.map((singleSymptom, index) =>
                            <IconList
                                key={index}
                                icon={singleSymptom.icon}
                                title={singleSymptom.title}
                                description={singleSymptom.description}
                            />
                        )
                    }
                </div>
            </div>
        </section>
    );
};

export default Symptoms;
